<ub-card [variant]="user.doc.state === 'active' ? 'success' : 'warn'" [rounded]="true" [dividers]="false">
  <h3 title><a [routerLink]="[user.doc.user, 'dashboard']">{{ user.fullname }}</a></h3>
  <div actions>
    <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
  </div>
  <div content>
    <ub-simple-list>
      <ub-simple-list-item>
        <ub-label label="Email" text="{{ user.doc.email }}" i18n-label></ub-label>
      </ub-simple-list-item>
      <ub-simple-list-item>
        <ub-label variant="primary" text="{{ state }}"></ub-label>
      </ub-simple-list-item>
    </ub-simple-list>
  </div>
</ub-card>
